import React from "react"
import { Typography } from "@mui/material"
import type { ValidationError } from "./ValidationSchema.tsx"

interface ValidationErrorsProps {
  errors: ValidationError[]
  fieldPrefix?: string
}

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({ errors, fieldPrefix = "" }) => {
  // Filter errors by field prefix if provided
  const filteredErrors = fieldPrefix ? errors.filter((error) => error.field.startsWith(fieldPrefix)) : errors

  if (filteredErrors.length === 0) return null

  return (
    <div className="validation-errors">
      {filteredErrors.map((error, index) => (
        <Typography key={index} color="error" variant="caption" sx={{ display: "block", mt: 0.5 }}>
          {error.message}
        </Typography>
      ))}
    </div>
  )
}

export const FieldError: React.FC<{
  errors: ValidationError[]
  field: string
}> = ({ errors, field }) => {
  const error = errors.find((e) => e.field === field)

  if (!error) return null

  return (
    <Typography color="error" variant="caption" sx={{ display: "block", mt: 0.5 }}>
      {error.message}
    </Typography>
  )
}
